import React, { useEffect } from 'react';
import '../styles/animations.css';

export default function TokenDropAnimation({ label, onComplete }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="token-drop-overlay">
      <div className="token-drop-coin" style={{ fontSize: 28 }}>&#127807;</div>
      <div className="token-drop-label">{label}</div>
    </div>
  );
}
